import api from '../../../lib/api'

export interface AutomationRule {
  id: number
  tenant_id: number
  name: string
  description: string | null
  rule_type: 'status_delay' | 'renewal_schedule'
  trigger_status: string | null
  delay_hours: number | null
  days_before: number[] | null
  template_name: string
  is_active: boolean
  created_by: number | null
  created_at: string
  updated_at: string
}

export interface AutomationRuleLog {
  id: number
  rule_id: number
  lead_id: number
  template_name: string
  status: 'SENT' | 'FAILED' | 'SKIPPED'
  error_message: string | null
  skip_reason: string | null
  variables_used: Record<string, string> | null
  days_before_offset: number | null
  triggered_by: number | null
  scheduled_at: string | null
  executed_at: string | null
  created_at: string
  customer_name: string | null
  vehicle_reg_no: string | null
  insurance_due_date: string | null
}

export interface RunSummary {
  rules_evaluated: number
  leads_matched: number
  sent: number
  failed: number
  skipped: number
  triggered_by: string | null
}

export interface AutomationStats {
  active_rules: number
  today_total: number
  today_sent: number
  today_failed: number
  today_skipped: number
}

export interface RuleCreate {
  name: string
  description?: string
  rule_type: 'status_delay' | 'renewal_schedule'
  trigger_status?: string
  delay_hours?: number
  days_before?: number[]
  template_name: string
  is_active: boolean
}

export const automationService = {
  async listRules(): Promise<AutomationRule[]> {
    const { data } = await api.get('/automation/rules')
    return data
  },

  async createRule(payload: RuleCreate): Promise<AutomationRule> {
    const { data } = await api.post('/automation/rules', payload)
    return data
  },

  async updateRule(id: number, payload: Partial<RuleCreate & { is_active: boolean }>): Promise<AutomationRule> {
    const { data } = await api.patch(`/automation/rules/${id}`, payload)
    return data
  },

  async deleteRule(id: number): Promise<void> {
    await api.delete(`/automation/rules/${id}`)
  },

  async getRuleLogs(ruleId: number): Promise<AutomationRuleLog[]> {
    const { data } = await api.get(`/automation/rules/${ruleId}/logs`)
    return data
  },

  async getAllLogs(status?: string): Promise<AutomationRuleLog[]> {
    const { data } = await api.get('/automation/logs', { params: status ? { status } : {} })
    return data
  },

  async getStats(): Promise<AutomationStats> {
    const { data } = await api.get('/automation/stats')
    return data
  },

  async runNow(): Promise<RunSummary> {
    const { data } = await api.post('/automation/run')
    return data
  },
}
